/************************************************************************************
 * [COMPONENT]: BACK TO TOP
 *************************************************************************************/

class BackToTop extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.buttonEl = this.querySelector('button')

		window.addEventListener('scroll', this.onScroll.bind(this))
		this.buttonEl.addEventListener('click', this.onClick.bind(this))
	}

	onScroll() {
		const isActive = window.scrollY > 500
		this.classList.toggle('is-active', isActive)
	}

	onClick() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}
}

window.customElements.define('l-back-to-top', BackToTop)

